import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/CompanyRequestAssistant.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/CategoryBadgePills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
